import * as t from 'io-ts'
import { isLeft } from 'fp-ts/lib/Either'

export interface TypeO<A, B = A> extends t.Type<A, B, unknown> {}
export interface TypeMixed<A> extends TypeO<A, unknown> {}

export declare const asMixed: <A>(O: t.Type<A, unknown, unknown>) => TypeMixed<A>

export class NumberFromStringType extends t.Type<number, string> {
  readonly _tag: 'NumberFromStringType' = 'NumberFromStringType'
  constructor() {
    super(
      'NumberFromString',
      t.number.is,
      (m, c) => {
        const validation = t.string.validate(m, c)
        if (isLeft(validation)) {
          return validation as any
        } else {
          const s = validation.right
          const n = ((s as any) as number) * 1 // known fact
          return isNaN(n) ? t.failure(s, c) : t.success(n)
        }
      },
      String
    )
  }
}

export const NumberFromString = new NumberFromStringType()



// WEBPACK FOOTER //
// ./src/framework/io-ts.ts